/**
 * NoProjectHeader.jsx
 * Empty header for pages that do not requires a header
 */
import React from 'react';

export const NoProjectHeader = () => {
  return <div />
}
